"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { FiChevronDown, FiChevronRight } from "react-icons/fi";
import ChargeTimeline from "@/components/billing/timeline";
import { ChargeBadge } from "@/lib/billing/charge-badge";
import { formatCurrency, formatDate, formatStaffName } from "@/lib/format-data";
import { cx } from "@/lib/tailwind-utils";
import type { ChargeTableItem } from "@/types/charge";
import { PatientSidebarSectionSkeleton } from "./section-skeleton";
import { chargeQueryOptions } from "@/api/provider/billing/charge-query";
interface Props {
  patientId: string;
}
export default function ChargesSection(t0) {
  const $ = _c(18);
  const {
    patientId
  } = t0;
  let t1;
  if ($[0] !== patientId) {
    t1 = chargeQueryOptions.table(patientId);
    $[0] = patientId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !!patientId;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      ...t1,
      enabled: t2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: t4,
    isPending
  } = useQuery(t3);
  let t5;
  if ($[5] !== t4) {
    t5 = t4 === undefined ? [] : t4;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const charges = t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = new Set();
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const [expanded, setExpanded] = useState(t6);
  if (isPending) {
    let t7;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <PatientSidebarSectionSkeleton />;
      $[8] = t7;
    } else {
      t7 = $[8];
    }
    return t7;
  }
  if (!charges || charges.length === 0) {
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <p className="text-caption text-muted-foreground">No charges created</p>;
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    return t7;
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = id => {
      setExpanded(prev => {
        const next = new Set(prev);
        if (next.has(id)) {
          next.delete(id);
        } else {
          next.add(id);
        }
        return next;
      });
    };
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const toggle = t7;
  let t8;
  if ($[11] !== charges || $[12] !== expanded) {
    let t9;
    if ($[14] !== expanded) {
      t9 = charge => {
        const isOpen = expanded.has(charge.id);
        return <div key={charge.id} className="mb-4"><button type="button" onClick={() => toggle(charge.id)} className={cx("group w-full rounded-md text-left", "focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40")} aria-expanded={isOpen} aria-controls={`charge-timeline-${charge.id}`}><div className="flex items-start gap-2"><span className="mt-0.5 text-foreground-muted group-hover:text-foreground-secondary">{isOpen ? <FiChevronDown className="h-3.5 w-3.5" /> : <FiChevronRight className="h-3.5 w-3.5" />}</span><div className="min-w-0 flex-1"><ChargeBadge status={charge.status} /><div className="mt-1 flex items-center justify-between gap-2"><div className="min-w-0"><p className="font-medium text-foreground">{formatCurrency(charge.total)}</p>{charge.totalOutstanding > 0 && <p className="text-caption-strong text-red-500">{formatCurrency(charge.totalOutstanding)} still outstanding</p>}</div><div className="text-right">{charge.creator && charge.createdDate && <p className="text-caption text-foreground-secondary">Created by {formatStaffName(charge.creator)} on{" "}{formatDate(charge.createdDate)}</p>}</div></div>{charge.description && <p className="mt-1 text-caption text-foreground-secondary">{charge.description}</p>}{charge.comment && <p className="mt-1 text-caption italic text-foreground-secondary">“{charge.comment}”</p>}</div></div></button>{isOpen && <div id={`charge-timeline-${charge.id}`} className="mt-2 min-w-0 border-l border-border pl-2"><ChargeTimeline chargeId={charge.id} /></div>}</div>;
      };
      $[14] = expanded;
      $[15] = t9;
    } else {
      t9 = $[15];
    }
    t8 = charges.map(t9);
    $[11] = charges;
    $[12] = expanded;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <>{t8}</>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}